import axios from 'axios';
import { getSessionKey } from '../utils/session';

const apiClient = axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
	headers: {
		'X-App-Id': '5',
		'X-App-Key': 'TpB2R6XDzaDpxbLU1x2r9NVJtSLqVBUk',
	},
});

// Attach the visitor-session key to every call. content_manager#GetOneBySlug resolves it
// (session_key -> visitor_session_info.id) and only then records the Blog_View statistic
// and the session_article row that makes article->order attribution possible. Without the
// header the API silently skips both, which is why this site had no article telemetry.
apiClient.interceptors.request.use((config) => {
	const key = getSessionKey();
	if (key) {
		config.headers = config.headers ?? {};
		(config.headers as Record<string, string>)['X-SESSION-ID'] = key;
	}
	return config;
});

/**
 * Register the session once per browsing session. The API keys visitor_session_info on the
 * X-SESSION-ID header and runs bot detection before storing anything, so crawlers are
 * filtered server-side.
 *
 * Fire-and-forget by design: analytics must never delay or break a page render, so the
 * promise is swallowed. Guarded by a module-level flag so React StrictMode's double-invoke
 * (and any re-import) cannot double-register.
 */
let registered = false;
export function registerVisitorSession(): void {
	if (registered) return;
	registered = true;
	// Skip the prerender pass. The deploy renders every route in headless Chrome, which
	// would otherwise POST one session per route on every deploy. The API already refuses
	// these (BotDetector matches 'headlesschrome'/'puppeteer' and the prerender does not
	// spoof its UA), so this is belt-and-braces — it just avoids the pointless requests.
	if (typeof navigator !== 'undefined' && navigator.webdriver) return;
	if (!getSessionKey()) return;
	try {
		apiClient
			.post('/visitor_session', {
				landing_page_url: typeof window !== 'undefined' ? window.location.href : '',
				// Without the referrer every non-UTM session read as "direct" (59 of 61
				// visits in Sept 2026) — Direkt cleanup plan 2026-09-27, Phase 0.
				referrer_url: typeof document !== 'undefined' ? document.referrer : '',
			})
			.catch(() => {
				/* analytics is best-effort */
			});
	} catch {
		/* never surface to the UI */
	}
}

export default apiClient;
